import { KeyValue } from '@angular/common';
import { Component, Input } from '@angular/core';
import { VrmTrainingResponse } from '../../services/drilldown-forms.service';

import { CommonService } from '../../services/common.service';

@Component({
  selector: 'vrm-training-activity',
  templateUrl: './vrm-training-activity.component.html',
  styleUrls: ['./vrm-training-activity.component.scss'],
})
export class VrmTrainingActivityComponent {
  public readonly String = String;

  constructor(public cService: CommonService) {}

  @Input() cardTitle: string;
  @Input() driverModules: VrmTrainingResponse = { data: [] };

  // This is to preserve order on the keyvalue pipe
  preserveOrder = (a: KeyValue<string, any>, b: KeyValue<string, any>): number => {
    return 0;
  };

  getNotStartedPhaseChipClass = (value: any): string => {
    let className = '';

    if (value.notStarted === 0) {
      className = 'green-color';
    } else if (this.cService.userProfile?.userPermissions?.permDueDates === this.cService.permLevels.TRUE) {
      className = 'amber-color';
    } else {
      className = 'red-color';
    }

    return className;
  };

  getModuleDataClass = (value: any): string => {
    if (typeof value === 'string') {
      if (['yes', 'low', 'complete', 'agree'].includes(value.toLowerCase())) {
        return 'green-text';
      } else if (
        ['medium', 'incomplete'].includes(value.toLowerCase()) ||
        ('not started' === value.toLowerCase() &&
          this.cService.userProfile?.userPermissions?.permDueDates === this.cService.permLevels.TRUE)
      ) {
        return 'amber-text';
      } else if (['no', 'high', 'not started', 'overdue'].includes(value.toLowerCase())) {
        return 'red-text';
      }
    }

    return '';
  };
}
